export interface BaseModel<T> {
  getDataValues?(): Readonly<Record<string, any>>;
}

export abstract class BaseModel<T> {
  protected dataValues: Record<string, any> = {};

  abstract toJson(): Record<string, unknown>;
}
